import { Invite } from '@gen2/types/invite';
import { create } from 'zustand';

const defaultInvite: Invite = {
  id: '',
  name: 'Untitled Invite',
  message: '',
  due_at: null,
  created_at: '',
  subject: '',
  contacts: [],
  status: 'draft',
};
export interface IInviteListingStore {
  invite: Invite;
  isFetchingInvite: boolean;
  isLoadingInvite: boolean;
  setInvite: (invite: Invite) => void;
  setInviteIsFetching: (isFetchingInvite: boolean) => void;
  setIsLoadingInvite: (isLoading: boolean) => void;
}

export const useInviteListingItemStore = create<IInviteListingStore>((set) => ({
  invite: defaultInvite,
  isFetchingInvite: false,
  isLoadingInvite: false,
  setInvite: (invite: Invite) => set({ invite }),
  setInviteIsFetching: (isFetchingInvite: boolean) => set({ isFetchingInvite }),
  setIsLoadingInvite: (isLoading: boolean) =>
    set({ isLoadingInvite: isLoading }),
}));
